import App from './App';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { jsx as _jsx } from "react/jsx-runtime";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(/*#__PURE__*/ _jsx(App, {})); // If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); // import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
//
// import './styles/index.less';
//
// const root = ReactDOM.createRoot(document.getElementById('root'));
//
// root.render(<App/>);
